import * as React from "react";
import { FC } from "react";
import * as Yup from "yup";
import { Field, Form, FormikValues } from "formik";
import FormikForm from "~/lib/forms/FormikForm";
import Input from "~/common/controls/Input";
import Button from "~/common/elements/mobile/Button";
import { buttonSize, buttonStyle } from "~/common/elements/mobile/consts";

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
});

type InitialValues = {
  name: string;
};

type Props = {
  initialValues: InitialValues;
  error: string;
  onSubmit: (data: FormikValues) => void;
  onClose: () => void;
};

const ProductSegmentForm: FC<Props> = ({ initialValues, error, onSubmit, onClose }) => {
  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={ValidationSchema}
      enableReinitialize
    >
      <Form className="form__cont">
        <Field name="name" label="Name" type="text" component={Input} className="input input--bubble" />

        {error && <div className="form__note form__note--err">{error}</div>}

        <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "40px" }}>
          <Button title={"Cancel"} buttonStyle={buttonStyle.WARN} buttonSize={buttonSize.LG} onClick={onClose} />
          <button className="btn btn--prim btn--lg" type="submit">
            Submit
          </button>
        </div>
      </Form>
    </FormikForm>
  );
};

export default ProductSegmentForm;
